import { DocumentMinimap } from 'features/knowledgeDocumentViewer/components/viewer/shared/DocumentMinimap'
import {
  type TransformStore,
  useTransformStoreState,
} from 'features/knowledgeDocumentViewer/components/viewer/shared/transformStore'
import React from 'react'

type LiveDocumentMinimapProps = Omit<
  React.ComponentProps<typeof DocumentMinimap>,
  'transformState'
> & { transformStore: TransformStore }

export const LiveDocumentMinimap: React.FC<LiveDocumentMinimapProps> = ({
  transformStore,
  ...minimapProps
}) => {
  const transformState = useTransformStoreState(transformStore)
  return <DocumentMinimap transformState={transformState} {...minimapProps} />
}
